<template>
  <vs-popup class="user-edit-popup"
            id="popup"
            title="UPDATE TENANT"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                <small class="label">First Name</small>
                <vs-input v-model="createStaffForm.first_name"   name="first_name" class="w-full required" label=""
                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                <small class="label">Last Name</small>
                <vs-input v-model="createStaffForm.last_name"   name="last_name" class="w-full required" label=""
                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col  md:w-full w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required|email" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input  v-model="createStaffForm.email" class="w-full"  name="email" type="text" label=""
                           :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const TenantRepository = RepositoryFactory.get('tenant');
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      createStaffForm: {},
      id: '',
    }
  }

export default {
  name: 'CreateTenantPopUp',
  data () {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],

  methods:{
    async openPopup (id) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset()
        this.id = id
        await this.fetchTenantDetails()
        this.open = true;
      } catch (error) {

      }
    },

    async onClickCreateStaffUser () {
      const vue = this;
      this.$vs.loading()
       try {
         const form = {
           first_name: this.createStaffForm.first_name,
           last_name: this.createStaffForm.last_name,
           email: this.createStaffForm.email,
         }
         await TenantRepository.updateTenant(this.createStaffForm.id, form)
         this.showSuccessMessage('Tenant updated successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    onClickReset() {
      this.createStaffForm = {}
    },
    async fetchTenantDetails() {
      try {
        const { data } = (await TenantRepository.getTenantDetails(this.id)).data
        this.createStaffForm = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    }
  },
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
